export default __webpack_public_path__ + "static/media/logo-nih-niaid-text-white.d3806d22.svg";